import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

export interface LottieAnimationProps {
  src: string; // relative path to .lottie file in /assets/lottie
  loop?: boolean;
  autoplay?: boolean;
  style?: React.CSSProperties;
  className?: string;
}

const LottieAnimation: React.FC<LottieAnimationProps> = ({
  src,
  loop = true,
  autoplay = true,
  style,
  className,
}) => (
  <DotLottieReact src={src} loop={loop} autoplay={autoplay} style={style} className={className} />
);

export default LottieAnimation;
